import React, { useEffect } from "react";
import { fetchPrintConfig, postPrintConfig } from "../api/printConfig";
import { PrintConfig } from "../types";
import { DEFAULT_PRINT_CONFIG } from "../printConfig.constants";

export interface PrintLayout {
  printConfig: PrintConfig;
  orgId: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  _id: { $oid: string };
  printType: string;
}
export const defaultConfig: PrintLayout = {
  printConfig: DEFAULT_PRINT_CONFIG,
  orgId: "",
  isDeleted: false,
  createdAt: "",
  updatedAt: "",
  _id: { $oid: "default" },
  printType: "default",
};
const usePrintConfig = () => {
  const [printConfig, setPrintConfig] = React.useState<PrintLayout[]>([]);

  // Fetch the print configuration when the component mounts//
  const getPrintConfig = async () => {
    fetchPrintConfig()
      .then((res) => {
        const getData: PrintLayout[] = res.data;
        setPrintConfig([defaultConfig, ...getData]);
      })
      .catch((error) => {
        console.error("Failed to fetch print config:", error);
      });
  };
  useEffect(() => {
    getPrintConfig();
  }, []);

  // Function to update the print layout//
  const postLayout = (layout: any) => {
    const checkLayoutType = printConfig.length;
    if (checkLayoutType < 4) {
      postPrintConfig({ ...layout, printType: `Layout ${checkLayoutType}` })
        .then((updatedConfig) => {
          getPrintConfig(); // Refresh the config after updating
        })
        .catch((error) => {
          console.error("Failed to update print config:", error);
        });
    }
  };
  return { printConfig, postLayout };
};

export default usePrintConfig;
